import { WhatsappCampaignStatus } from "../../../../../model/integration/types/whatsapp/WhatsappCampaignStatus.enum";

/** Can still send, so it holds the number until it finishes or is deleted */
export const CURRENT_CAMPAIGN_STATUSES = [
  WhatsappCampaignStatus.ACTIVE,
  WhatsappCampaignStatus.PAUSED,
];
